import { render, staticRenderFns } from "./MultipleBuildings.vue?vue&type=template&id=c257f0f0&"
import script from "./MultipleBuildings.vue?vue&type=script&lang=js&"
export * from "./MultipleBuildings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports